import flatten from "lodash/flatten";
import { WSInfiniteQueryConfig } from "@ws-react-query";
import { IWorkDefinition } from "@wingspanhq/payments/dist/interfaces";
import {
  ApiQueryListWorkDefinitions,
  listWorkDefinitions
} from "../../../services/workDefinition";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSInfiniteQuery } from "../../helpers";

const PAGE_SIZE = 20;

export const QUERY_WORK_DEFINITIONS = "QUERY_WORK_DEFINITIONS";

export const useQueryWorkDefinitions = (
  requestQuery?: ApiQueryListWorkDefinitions,
  config?: WSInfiniteQueryConfig<IWorkDefinition[], WSServiceError>
) => {
  const query = useWSInfiniteQuery<IWorkDefinition[], WSServiceError>(
    [QUERY_WORK_DEFINITIONS, requestQuery],
    ({ pageParam = 1 }) => {
      return listWorkDefinitions({
        ...requestQuery,
        page: {
          size: requestQuery?.page?.size || PAGE_SIZE,
          number: pageParam
        }
      });
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage.length < PAGE_SIZE) {
          return undefined;
        } else {
          return allPages.length + 1;
        }
      },
      ...config
    }
  );

  return {
    ...query,
    data: query.data ? flatten(query.data.pages) : undefined
  };
};
